import { UI_MODE } from 'framework-listing-lib/constants';
import AsyncListingLibCalendarLayout from 'framework-listing-lib/internal/Calendar/AsyncListingLibCalendarLayout';
import AsyncListingLibGalleryUIMode from 'framework-listing-lib/internal/Table/components/AsyncListingLibGalleryUIMode';
import CrmListingTable from 'framework-listing-lib/internal/Table/components/CrmListingTable';
import useUIMode from 'framework-listing-lib/internal/hooks/useUIMode';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibLayout(props) {
  const {
    currentUIMode
  } = useUIMode();
  switch (currentUIMode) {
    case UI_MODE.CALENDAR:
      return /*#__PURE__*/_jsx(AsyncListingLibCalendarLayout, Object.assign({}, props));
    case UI_MODE.GALLERY:
      return /*#__PURE__*/_jsx(AsyncListingLibGalleryUIMode, Object.assign({}, props));
    case UI_MODE.LIST:
    case UI_MODE.FOLDERS:
    default:
      return /*#__PURE__*/_jsx(CrmListingTable, Object.assign({}, props));
  }
}